var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomepageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.909097 6.05749H6.4451C6.4451 6.05749 5.10311 7.4138 4.27183 8.25348C3.91693 8.6123 3.91693 9.19401 4.27183 9.55282C4.33038 9.61199 4.38964 9.67169 4.44819 9.73086C4.80309 10.0897 5.37873 10.0897 5.73384 9.73086C6.82183 8.63159 8.9809 6.44955 9.73366 5.68872C9.9042 5.51656 10 5.28286 10 5.03923V4.9606C10 4.71716 9.9042 4.48345 9.73366 4.31111C8.9809 3.55042 6.82183 1.36842 5.73384 0.269113C5.37873 -0.0897043 4.80309 -0.0897043 4.44819 0.269113C4.38964 0.328099 4.33038 0.388202 4.27183 0.447152C3.91693 0.806005 3.91693 1.38753 4.27183 1.74635C5.10311 2.58621 6.4451 3.94252 6.4451 3.94252H0.909097C0.406917 3.94252 0 4.3539 0 4.86119V5.13882C0 5.64629 0.406917 6.05749 0.909097 6.05749Z",
    fill: "#7783A1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageArrow);
export default __webpack_public_path__ + "static/media/homepage_arrow.563b4086cce2ef9da55ccf96aeb8821b.svg";
export { ForwardRef as ReactComponent };